import MatchMedia from '@/js/core/MatchMedia'
import gsap from 'gsap'
import $ from 'jquery'

export default class ProfessionalsList extends MatchMedia {
    static root = '[data-list-follow]'

    selectors = {
      'target': '[data-mouse-follow-target]',
      'trigger': '[data-mouse-follow-trigger]',
    }
    
    actions = {
      breakpointSMMatches: 'update'
    }
  
    move ({ pageX, pageY }) {
      const offset = this.$.trigger.offset()
      const height = this.$.trigger.height()
      const width = this.$.trigger.width()

      const wvh = window.innerHeight;
      const wvw = window.innerWidth;

      const x = pageX - 190
      const y = pageY - (offset.top + height / 2 + 90)
  
      gsap.to(this.$els.target, { x, y, duration: 1, ease: 'expo.out' })
  
      // if (pageX < offset.left || pageX > offset.left + width || 
      //     pageY < offset.top || pageY > offset.top + height) {
      //   this.reset()
      // }
    }
  
    follow () {
      document.addEventListener('mousemove', this.move.bind(this))
      this.addHover()  
    }

    addHover() {
      document.querySelectorAll('[data-mouse-follow-trigger]').forEach((el) => {
        el.addEventListener('mousemove', (e) => {
            document.querySelector('[data-mouse-follow-target]').style.opacity  = 1
            document.querySelector('[data-mouse-follow-target] .image-cursor_images').style.left = (e.target.getAttribute('data-id') * -100) + '%';
        })
        el.addEventListener('mouseleave', () => {
          document.querySelector('[data-mouse-follow-target]').style.opacity = 0
        })
      }) 
    }
    
    reset () {
      // document.querySelectorAll('[data-mouse-follow-trigger]').forEach((el) => {
      //   el.removeEventListener('mousemove', this.follow.bind(this))
      //   el.removeListener('mouseleave', this.follow.bind(this))
      // })   
      
      // gsap.to(this.$els.target, { x: "50%", y: "50%", duration: 1, ease: 'expo.out', clearProps: 'all' })
    }
  
    addListeners () {
      this.follow()
      // document.querySelectorAll('[data-mouse-follow-trigger]').forEach((el) => {
      //   el.addEventListener('mousemove', this.follow.bind(this))
      //   el.addEventListener('mouseleave', this.reset.bind(this))
      // })   
      
      // this.$.trigger.on('mouseenter', this.follow.bind(this))
      // this.$.trigger.on('mouseleave', this.reset.bind(this))
    }
  
    removeListeners () {
      // document.querySelectorAll('[data-mouse-follow-trigger]').forEach((el) => {
      //   el.removeEventListener('mousemove', this.follow.bind(this))
      //   el.removeListener('mouseleave', this.follow.bind(this))
      // })   
      
    }

    addCounter() {
      document.querySelectorAll('[data-mouse-follow-trigger]').forEach((el) => {
        let text = el.textContent
    
        text = text.replaceAll(', ', '')
        el.textContent = text
        text = text.replaceAll('I', '')
        text = text.replaceAll('i', '')
        text = text.replaceAll('l', '')
        console.log(text);
        const c = text.length
        
        el.setAttribute('data-counter', c)
        el.style.fontSize = (95 / c) + 'vw';
        el.style.lineHeight = ((95 / c) + 3) + 'vw';
      });
    }
  
    update () {
      const { breakpointSMMatches } = this.state
      
      if (breakpointSMMatches === undefined) return
  
      if (breakpointSMMatches) {
        this.removeListeners()
        return 
      }
  
      if (!$.device.mobile) {
        this.addListeners()
      }else{
        // this.addCounter()
      }
       
    }
  }